const getStackTrace = () => {
    const dummyError = new Error();
    return dummyError.stack ? dummyError.stack.toString() : '';
};
export const getAppUrl = appName => {
    const urlMatches = getStackTrace().match(new RegExp(`https?://.*?${appName}.*?.js`));
    return urlMatches ? urlMatches[0] : '';
};
export const isLocalhost = () => /localhost|127\.0\.0\.1|::1|\.local|local.wix.com|^$/i.test(window.location.hostname);
//# sourceMappingURL=getUrl.js.map